import React, { FC } from 'react';

const IconSaving: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        d="M17.8670854,8.42298915 C17.234883,9.05553445 16.2094986,9.05553445 15.5772962,8.42334273 C14.9447401,7.79079743 14.9447401,6.76543055 15.5772962,6.13288526 C16.2094986,5.50104711 17.234883,5.50104711 17.8670854,6.13323883 C18.4989343,6.76543055 18.4989343,7.79044386 17.8670854,8.42298915 M19.9984705,10.8623016 L19.9988241,5.61277675 C19.9988241,4.72388973 19.2768121,4.00189002 18.3882635,4.00153644 L13.1382958,4.00189002 C13.1382958,4.00189002 12.1595841,3.9460252 11.6642174,4.44173705 L4.45293701,11.6525413 C3.849021,12.2568006 3.849021,13.2354956 4.45293701,13.8394013 L10.1604383,19.5468055 C10.7647079,20.1510648 11.7437731,20.1510648 12.3476891,19.5468055 L19.558616,12.3356477 C20.0497397,11.8445324 19.9984705,10.8623016 19.9984705,10.8623016"
        transform="translate(-4 -4)"
      />
    </svg>
  );
};

export default IconSaving;
